import React from 'react';

import { PageTitle } from '../../Text';

export default () => (
  <div className="primary-content">
    <PageTitle>Applicant Details</PageTitle>
    <p>
      This application form is appropriate for individuals applying to renew
      their CPCS Competent Operator card via the logbook or competence
      assessment route
    </p>
  </div>
);
